import { Component, EventEmitter } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { IDirectoryColumnEditComponent } from 'src/app/samwebDescription/samweb/directory/directory-column-edit-component';
import { OrganisationEntryRemoteDto } from 'src/generated/swagger';

@Component({
   selector: 'samweb-base-directory-edit',
   templateUrl: './base-directory-edit.component.html',
   styleUrls: ['./base-directory-edit.component.scss'],
})
export class BaseDirectoryEditComponent implements IDirectoryColumnEditComponent {
   icon: IconDefinition;
   header: string;
   value: string | number | boolean | Date;
   valueOriginal: string | number | boolean | Date;
   valueUpdated: string | number | boolean | Date;
   isComparatorActive: boolean;
   isFocused: boolean;
   isDisabled: boolean;
   orgdata: OrganisationEntryRemoteDto[];
   orgUnit: string;
   valueChanged: EventEmitter<any>;
   takeMine: EventEmitter<any>;
   takeOther: EventEmitter<any>;
   constructor() {}
}
